import { motion, transform } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef, useState, useEffect } from "react";
import { cdnPath } from "@/utility/api";
import axios from "axios";
import { baseURL } from "@/utility/api";

import React from "react";
import { AnimatedTestimonials } from "../ui/animated-testimonials";

const InternshipTestimonial = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [testimonial, setTestimonial] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(
          `${baseURL}/testimonial/success-story`,
          { id: 2 }
        );
        setTestimonial(response.data);
      } catch (error) {
        console.error("Failed to fetch testimonials:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonial.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + testimonial.length) % testimonial.length
    );
  };

  return (
    <section id="success-stories" className="py-24 relative">
      {/* Background with dots + gradient overlay */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "radial-gradient(#404040 1px, transparent 1px)",
          backgroundSize: "20px 20px",
        }}
      />
      <div
        className="absolute inset-0 z-0"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 20%, black 70%)",
        }}
      />

      <div className="container mx-auto px-4 relative z-10" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-4"
        >
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            <span className="font-style-gradient">Success Stories</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Real People. Real Results.
          </p>
        </motion.div>

        {/* Timeline */}
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Only show loading for the testimonials component */}
            {isLoading || testimonial.length === 0 ? (
              <div className="flex justify-center items-center py-20">
                <div className="text-white">Loading testimonials...</div>
                {/* You can replace this with a proper loading spinner */}
              </div>
            ) : (
              <AnimatedTestimonials
                testimonials={testimonial}
                autoplay={true}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InternshipTestimonial;
